import { UserLogDtoToEntity } from "src/app/features/UserLog/services/mappers/UserLogDtoToEntity";
import type { UserLogDto } from "src/app/features/UserLog/types/UserLogDto";
import type { UserLogEntity } from "src/app/features/UserLog/types/UserLogEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const UserLogTableDtoMapper = (input: Readonly<ResourcePageDto<UserLogDto>>): ResourcePageEntity<UserLogEntity> => {
    return {
        list: input.list ? input.list.map(UserLogDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
